module.exports = __webpack_public_path__ + "images/stg_emoji.13852c54fdc6e7d5384ee898992f4329.svg";